import { render, staticRenderFns } from "./WhitelistList.vue?vue&type=template&id=72d46bbf&"
import script from "./WhitelistList.vue?vue&type=script&lang=js&"
export * from "./WhitelistList.vue?vue&type=script&lang=js&"
import style0 from "./WhitelistList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports